import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { constants } from 'src/app/shared/common/contants';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ManageVisualsService } from 'src/app/shared/services/manage-visuals.service';
import { PivotConfigurationPopupComponent } from '../filters/pivot-configuration-popup/pivot-configuration-popup.component';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';

@Component({
    selector: 'app-manage-visuals',
    templateUrl: './manage-visuals.component.html',
    styleUrls: ['./manage-visuals.component.scss'],
    standalone: false
})
export class ManageVisualsComponent implements OnInit {


  getdata

  gridApi;
  columnDefs;
  defaultColDef;
  paginationPageSize;
  paginationNumberFormatter;
  rowClassRules;
  components: any;

  backgroundColorScreen;
  buttonColor;
  buttonIdList: any = [];
  pagesize;
  currentpage;
  totalpages;
  lastpage;
  nextpage;
  nextpageplusone;

  constructor(
    private userRoutingModule:UserRoutingModule,
    private reportLinkService:ReportlinksserviceService,
    private localStorageSettings: LocalStorageSettingsService, 
    private visualServices:ManageVisualsService,
    private spinner: NgxUiLoaderService,
    private constants: constants,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) { 
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }

  ngOnInit(): void {

    /* @added by Chandra R
        @date 01-01-2025
        @@desc Below code enable and disable the buttons  in UI based on permission
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });


    this.columnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        values:this.buttonIdList,
        edit: this.EditIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      }, width: 150
    },
      { headerName: 'Visual Name', headerTooltip: 'Visual Name', tooltipValueGetter: (params) => 'Visual Name : ' + params.value, field: 'visualName', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Dataset', headerTooltip: 'Dataset', tooltipValueGetter: (params) => 'Dataset : ' + params.value, field: 'datasetname', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Visual Type', headerTooltip: 'Visual Type', tooltipValueGetter: (params) => 'Visual Type : ' + params.value, field: 'visualType', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Visual Configuration', headerTooltip: 'Visual Configuration', tooltipValueGetter: (params) => 'Visual Configuration : ' + params.value, field: 'visualConfig', filter: 'agTextColumnFilter', width: 300 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created By', headerTooltip: 'Created By', tooltipValueGetter: (params) => 'Created By : ' + params.value, field: 'createdBy', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created Date', headerTooltip: 'Created Date', tooltipValueGetter: (params) => 'Created Date : ' + params.value, field: 'createdDateAndTime', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Last Modified By', headerTooltip: 'Last Modified By', tooltipValueGetter: (params) => 'Last Modified By : ' + params.value, field: 'lastmodifiedBy', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Last Modified Date', headerTooltip: 'Last Modified Date', tooltipValueGetter: (params) => 'Last Modified Date : ' + params.value, field: 'lastModifiedDateAndTime', filter: 'agTextColumnFilter', width: 250 }
      
    ],
    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    // this.getVisuals();
  }

  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();
      this.currentpage = this.gridApi.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.paginationGoToLastPage();
  }
  

  onGridReady(params){
     this.gridApi = params.api;
    //this.gridColumnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
    // params.api.setGridOption('rowData', [])
    this.spinner.start();
    this.visualServices.retreiveManageVisualsData().subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = []; 
        this.gridApi.setGridOption('rowData', this.getdata)
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.setGridOption('rowData', this.getdata)
        this.spinner.stop();
      }
     
    })

  }

  EditIcon(event){
    console.log(event);

    if (event.rowData.status == "Yes") {
      let dialogRef = this.dialog.open(PivotConfigurationPopupComponent, {
        width: "90%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "95%",
        disableClose: true,
        data: {editData: event.rowData},
      });
  
      // subcribe the popup after close
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        this.getVisuals()
      });
    } else {
      this.snackbar.open(
        "Cannot edit object group which is already deleted.",
        "OK",
        {
          duration: 8000,
        }
      );
    }
  }
  deleteIcon(event) {
    console.log(event);
    if(event.rowData.status === "No"){
      this.snackbar.open("Selected visual is already deleted","OK",{duration:5000});
      return;
    }
    if(confirm("Are you sure you want to delete this Visual?")){
      
      this.spinner.start();
    this.visualServices.deleteManageVisualsData(event.rowData.visualId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
         this.spinner.stop();
         this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getVisuals()
       
      }
    })
    }
    
  }

  openPivotConfigurationPopup(){
    let dialogRef = this.dialog.open(PivotConfigurationPopupComponent, {
      width: "90%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "95%",
      disableClose: true,
      data: {},
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      // this.onGridReady(this.gridApi);
      this.getVisuals()
    });
  }

  getVisuals(){
    this.spinner.start();
    this.visualServices.retreiveManageVisualsData().subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.setGridOption('rowData', this.getdata)
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.setGridOption('rowData', this.getdata)
        this.spinner.stop();
      }
    })
  }
}
